export const CustomerSourceType = [
    {
        "id": "FACEBOOK",
        "name": "Facebook"
    },
    {
        "id": "YOUTUBE",
        "name": "Youtube"
    },
    {
        "id": "TIKTOK",
        "name": "Tiktok"
    },
    {
        "id": "GOOGLE",
        "name": "Google"
    },
    {
        "id": "REF_PARENT",
        "name": "Phụ huynh giới thiệu"
    },
    {
        "id": "REF_SALE",
        "name": "Sale tự tìm"
    },
    {
        "id": "OTHER",
        "name": "Khác/Hội thảo"
    },
    {
        "id": "GO_ROAD",
        "name": "Tới trường MKT"
    },
]